import { formatPrice } from '../utils/formatPrice';
/* eslint-disable */
import NavBar from "../components/NavBar";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { API } from '../context/AuthContext';
import CoinSearch from '../components/CoinSearch';

const ICON_PATHS = {
  layers: <><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></>,
  target: <><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="0.5" fill="currentColor"/></>,
  flag: <><line x1="5" y1="21" x2="5" y2="3"/><path d="M5 4h13l-3 4.5L18 13H5"/></>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/></>,
  check: <><polyline points="20 6 9 17 4 12"/></>,
  alert: <><path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z"/></>
};

function Icon({ name, size = 15, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      {ICON_PATHS[name]}
    </svg>
  );
}

const TABS = [
  { key: 'holdings', label: 'Holdings', icon: 'layers' },
  { key: 'exit', label: 'Exit ladder', icon: 'target' },
  { key: 'goals', label: 'Tax & goals', icon: 'flag' },
  { key: 'account', label: 'Account', icon: 'user' }
];

export default function Settings() {
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState(window.location.hash === "#exit" ? "exit" : "holdings");
  const [holdings, setHoldings] = useState([]);
  const [exitLadder, setExitLadder] = useState([]);
  const [lots, setLots] = useState([]);
  const [goals, setGoals] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [newHolding, setNewHolding] = useState({ coin_symbol: '', coin_name: '', amount: '', average_buy_price: '', buy_date: new Date().toISOString().split('T')[0] });
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [newRung, setNewRung] = useState({ coin_symbol: 'XRP', target_price: '', sell_percentage: '', is_moon_bag: false });
  const [editingRungId, setEditingRungId] = useState(null);
  const [editRungData, setEditRungData] = useState({});

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const [h, l, g, lotsRes] = await Promise.all([
        axios.get(`${API}/api/holdings`),
        axios.get(`${API}/api/exit-ladder`),
        axios.get(`${API}/api/wealth`),
        axios.get(`${API}/api/holdings/lots`)
      ]);
      setHoldings(h.data.holdings);
      setExitLadder(l.data.ladders);
      setGoals(g.data.goals || {});
      setLots(lotsRes.data.lots || []);
    } catch (err) {
      setError('Failed to load settings.');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (msg) => { setMessage(msg); setTimeout(() => setMessage(''), 3000); };

  const updateHolding = async (id) => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/holdings/${id}`, { amount: editData.amount, average_buy_price: editData.average_buy_price });
      if (editData.buy_date) {
        if (editData.lot_id) {
          await axios.put(`${API}/api/holdings/lots/${editData.lot_id}`, { amount: editData.amount, buy_price: editData.average_buy_price, buy_date: editData.buy_date });
        } else {
          await axios.post(`${API}/api/holdings/lots`, { holding_id: id, coin_symbol: holdings.find(h => h.id === id)?.coin_symbol, amount: editData.amount, buy_price: editData.average_buy_price, buy_date: editData.buy_date });
        }
      }
      const holdingsRes = await axios.get(`${API}/api/holdings`);
      setHoldings(holdingsRes.data.holdings);
      const lotsRes = await axios.get(`${API}/api/holdings/lots`);
      setLots(lotsRes.data.lots || []);
      setEditingId(null);
      showMessage("Holding updated.");
    } catch (err) { setError("Failed to update holding."); }
    finally { setSaving(false); }
  };
  const deleteHolding = async (id) => {
    if (!window.confirm('Remove this holding?')) return;
    try {
      await axios.delete(`${API}/api/holdings/${id}`);
      setHoldings(holdings.filter(h => h.id !== id));
      showMessage('Holding removed.');
    } catch (err) { setError('Failed to remove holding.'); }
  };

  const addHolding = async () => {
    if (!newHolding.coin_symbol || newHolding.coin_symbol.trim() === "" || !newHolding.amount || !newHolding.average_buy_price) { setError('Please fill in all fields.'); return; }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/api/holdings`, { ...newHolding, coin_name: newHolding.coin_name || newHolding.coin_symbol });
      if (newHolding.buy_date) {
        await axios.post(`${API}/api/holdings/lots`, { holding_id: res.data.holding.id, coin_symbol: newHolding.coin_symbol, amount: newHolding.amount, buy_price: newHolding.average_buy_price, buy_date: newHolding.buy_date });
      }
      setHoldings([...holdings, res.data.holding]);
      setNewHolding({ coin_symbol: '', coin_name: '', amount: '', average_buy_price: '', buy_date: new Date().toISOString().split('T')[0] });
    } catch (err) { setError('Failed to add holding.'); }
    finally { setSaving(false); }
  };

  const deleteRung = async (id) => {
    if (!window.confirm('Remove this exit target?')) return;
    try {
      await axios.delete(`${API}/api/exit-ladder/${id}`);
      setExitLadder(exitLadder.filter(r => r.id !== id));
      showMessage('Exit target removed.');
    } catch (err) { setError('Failed to remove exit target.'); }
  };
  const updateRung = async (id) => {
    setSaving(true);
    try {
      await axios.put(`${API}/api/exit-ladder/${id}`, editRungData);
      setExitLadder(exitLadder.map(r => r.id === id ? { ...r, ...editRungData } : r));
      setEditingRungId(null);
      showMessage("Exit target updated.");
    } catch (err) { setError("Failed to update exit target."); }
    finally { setSaving(false); }
  };

  const addRung = async () => {
    if (!newRung.target_price || !newRung.sell_percentage) { setError('Please fill in all fields.'); return; }
    setSaving(true);
    try {
      const res = await axios.post(`${API}/api/exit-ladder`, newRung);
      setExitLadder([...exitLadder, res.data.ladder]);
      setNewRung({ coin_symbol: 'XRP', target_price: '', sell_percentage: '', is_moon_bag: false });
      showMessage('Exit target added.');
    } catch (err) {
      if (err.response?.data?.upgrade) {
        setError("You have reached the free plan limit of 1 exit target. Upgrade to Pro for unlimited targets.");
      } else {
        setError(err.response?.data?.error || "Failed to add exit target.");
      }
    }
    finally { setSaving(false); }
  };

  const saveGoals = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/api/wealth`, goals);
      showMessage('Settings saved.');
    } catch (err) { setError('Failed to save settings.'); }
    finally { setSaving(false); }
  };

  const cancelSubscription = async () => {
    if (!window.confirm('Cancel your subscription? You keep access until end of billing period.')) return;
    try {
      await axios.post(`${API}/api/stripe/cancel`);
      showMessage('Subscription cancelled. Access continues until end of billing period.');
    } catch (err) { setError(err.response?.data?.error || 'Failed to cancel subscription.'); }
  };

  if (loading) return <div style={s.loading}>Loading settings...</div>;
  return (
    <div style={s.page}>
      <NavBar />
      <style>{`
        .st-tab:hover { background: rgba(0,0,0,0.05); color: #1a1a1a; }
        .st-tab-active:hover { background: #0f2a1c !important; color: #fff !important; }
        .st-input:focus { border-color: #4ade80 !important; box-shadow: 0 0 0 3px rgba(74,222,128,0.15); }
        .st-row:hover { box-shadow: 0 8px 20px -10px rgba(16,40,28,0.14); }
        .st-btn:hover { filter: brightness(1.06); }
        * { box-sizing: border-box; }
      `}</style>
      <div style={s.content}>
        <div style={s.sectionLabel}>Account settings</div>
        <h1 style={s.pageTitle}>Settings</h1>
        {message && <div style={s.success}><Icon name="check" size={14} color="#1a6b4a" /> {message}</div>}
        {error && <div style={s.error} onClick={() => setError('')}><Icon name="alert" size={14} color="#dc2626" /> {error} ✕</div>}
        <div style={s.tabs}>
          {TABS.map(tab => (
            <button key={tab.key} onClick={() => setActiveTab(tab.key)}
              className={activeTab===tab.key ? 'st-tab st-tab-active' : 'st-tab'}
              style={{...s.tab, ...(activeTab===tab.key ? s.tabActive : {})}}>
              <Icon name={tab.icon} size={14} /> {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'holdings' && (
          <div style={s.section}>
            <h2 style={s.sectionTitle}>Your holdings</h2>
            {holdings.length === 0 ? <p style={s.empty}>No holdings yet.</p> : holdings.map(h => (
              <div key={h.id} className="st-row" style={{...s.row, flexDirection: editingId === h.id ? "column" : "row", alignItems: editingId === h.id ? "flex-start" : "center"}}>
                {editingId === h.id ? (
                  <div style={{width:"100%"}}>
                    <div style={s.grid4}>
                      <div style={s.field}><label style={s.label}>Amount</label><input className="st-input" style={s.input} type="number" value={editData.amount} onChange={e => setEditData({...editData, amount: e.target.value})} /></div>
                      <div style={s.field}><label style={s.label}>Avg buy price ($)</label><input className="st-input" style={s.input} type="number" value={editData.average_buy_price} onChange={e => setEditData({...editData, average_buy_price: e.target.value})} /></div>
                      <div style={s.field}><label style={s.label}>Purchase date</label><input className="st-input" style={s.input} type="date" value={editData.buy_date || ""} onChange={e => setEditData({...editData, buy_date: e.target.value})} /></div>
                    </div>
                    <div style={{display:"flex", gap:"8px", marginTop:"0.75rem"}}>
                      <button onClick={() => updateHolding(h.id)} className="st-btn" style={s.btn} disabled={saving}>{saving ? "Saving..." : "Save changes"}</button>
                      <button onClick={() => setEditingId(null)} style={s.cancelBtn}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div style={s.rowLeft}>
                      <div style={s.badge}>{h.coin_symbol}</div>
                      <div>
                        <div style={s.rowTitle}>{h.coin_symbol}</div>
                        <div style={s.rowSub}>{parseFloat(h.amount).toLocaleString()} coins · avg ${formatPrice(parseFloat(h.average_buy_price))}{(() => { const lot = lots.find(l => parseInt(l.holding_id) === parseInt(h.id)); return lot ? ` · purchased ${new Date(lot.buy_date).toLocaleDateString("en-US", {month:"short", day:"numeric", year:"numeric"})}` : ""; })()}</div>
                      </div>
                    </div>
                    <div style={{display:"flex", gap:"8px"}}>
                      <button onClick={() => { setEditingId(h.id); const lot = lots.find(l => parseInt(l.holding_id) === parseInt(h.id)); setEditData({amount: parseFloat(h.amount).toString(), average_buy_price: parseFloat(h.average_buy_price).toFixed(4), buy_date: lot ? lot.buy_date.split("T")[0] : "", lot_id: lot ? lot.id : null}); }} style={s.editBtn}>Edit</button>
                      <button onClick={() => deleteHolding(h.id)} style={s.deleteBtn}>Remove</button>
                    </div>
                  </>
                )}
              </div>
            ))}
            <div style={s.addSection}>
              <h3 style={s.addTitle}>Add holding</h3>
              <div style={s.grid4}>
                <div style={s.field}><label style={s.label}>Coin</label><CoinSearch value={newHolding.coin_symbol} onChange={val => setNewHolding({...newHolding, coin_symbol: val})} onSelect={(symbol, name) => setNewHolding({...newHolding, coin_symbol: symbol, coin_name: name})} /></div>
                <div style={s.field}><label style={s.label}>Amount</label><input className="st-input" style={s.input} type="number" value={newHolding.amount} onChange={e => setNewHolding({...newHolding, amount: e.target.value})} placeholder="10000" /></div>
                <div style={s.field}><label style={s.label}>Avg buy price ($)</label><input className="st-input" style={s.input} type="number" value={newHolding.average_buy_price} onChange={e => setNewHolding({...newHolding, average_buy_price: e.target.value})} placeholder="0.80" /></div>
                <div style={s.field}><label style={s.label}>Purchase date</label><input className="st-input" style={s.input} type="date" value={newHolding.buy_date} onChange={e => setNewHolding({...newHolding, buy_date: e.target.value})} /></div>
              </div>
              <button onClick={addHolding} className="st-btn" style={s.btn} disabled={saving}>{saving ? 'Adding...' : 'Add holding'}</button>
            </div>
          </div>
        )}

        {activeTab === "exit" && (
          <div style={s.section}>
            <h2 style={s.sectionTitle}>Exit ladder</h2>
            {exitLadder.length === 0 ? <p style={s.empty}>No exit targets set.</p> :
              Object.entries(exitLadder.reduce((acc, r) => {
                if (!acc[r.coin_symbol]) acc[r.coin_symbol] = [];
                acc[r.coin_symbol].push(r);
                return acc;
              }, {})).map(([symbol, rungs]) => (
                <div key={symbol} style={{marginBottom:"1.5rem"}}>
                  <div style={{...s.badge, marginBottom:"0.75rem"}}>{symbol}</div>
                  {[...rungs].sort((a,b) => { if (a.is_moon_bag) return 1; if (b.is_moon_bag) return -1; return parseFloat(a.target_price) - parseFloat(b.target_price); }).map(r => (
                    <div key={r.id} className="st-row" style={{...s.rungRow, flexDirection: editingRungId === r.id ? "column" : "row", alignItems: editingRungId === r.id ? "flex-start" : "center", borderLeft:"3px solid " + (r.is_moon_bag ? "#d97706" : "#1a6b4a")}}>
                      {editingRungId === r.id ? (
                        <div style={{width:"100%"}}>
                          <div style={s.grid4}>
                            <div style={s.field}><label style={s.label}>Target price ($)</label><input className="st-input" style={s.input} type="number" value={editRungData.target_price} onChange={e => setEditRungData({...editRungData, target_price: e.target.value})} /></div>
                            <div style={s.field}><label style={s.label}>Sell %</label><input className="st-input" style={s.input} type="number" value={editRungData.sell_percentage} onChange={e => setEditRungData({...editRungData, sell_percentage: e.target.value})} /></div>
                            <div style={s.field}><label style={s.label}>Moon bag?</label><select className="st-input" style={s.input} value={editRungData.is_moon_bag} onChange={e => setEditRungData({...editRungData, is_moon_bag: e.target.value === "true"})}><option value="false">No</option><option value="true">Yes</option></select></div>
                          </div>
                          <div style={{display:"flex", gap:"8px", marginTop:"0.75rem"}}>
                            <button onClick={() => updateRung(r.id)} className="st-btn" style={s.btn} disabled={saving}>{saving ? "Saving..." : "Save changes"}</button>
                            <button onClick={() => setEditingRungId(null)} style={s.cancelBtn}>Cancel</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={s.rowLeft}>
                            <div>
                              <div style={s.rowTitle}>{r.is_moon_bag ? "Moon bag — hold " + r.sell_percentage + "%" : "Sell " + r.sell_percentage + "% at $" + parseFloat(r.target_price).toFixed(2)}</div>
                              <div style={s.rowSub}>{r.alert_triggered ? "✓ Alert triggered" : r.alert_enabled ? "Alert active" : "Alert off"}</div>
                            </div>
                          </div>
                          <div style={{display:"flex", gap:"8px"}}>
                            <button onClick={() => { setEditingRungId(r.id); setEditRungData({target_price: parseFloat(r.target_price).toFixed(2), sell_percentage: r.sell_percentage, is_moon_bag: r.is_moon_bag}); }} style={s.editBtn}>Edit</button>
                            <button onClick={() => deleteRung(r.id)} style={s.deleteBtn}>Remove</button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              ))
            }
            <div style={s.addSection}>
              <h3 style={s.addTitle}>Add exit target</h3>
              <div style={s.grid4}>
                <div style={s.field}><label style={s.label}>Coin</label><CoinSearch value={newRung.coin_symbol} onChange={val => setNewRung({...newRung, coin_symbol: val})} onSelect={(symbol) => setNewRung({...newRung, coin_symbol: symbol})} /></div>
                <div style={s.field}><label style={s.label}>Target price ($)</label><input className="st-input" style={s.input} type="number" value={newRung.target_price} onChange={e => setNewRung({...newRung, target_price: e.target.value})} placeholder="5.00" /></div>
                <div style={s.field}><label style={s.label}>Sell % </label><input className="st-input" style={s.input} type="number" value={newRung.sell_percentage} onChange={e => setNewRung({...newRung, sell_percentage: e.target.value})} placeholder="10" /></div>
                <div style={s.field}><label style={s.label}>Moon bag?</label>
                  <select className="st-input" style={s.input} value={newRung.is_moon_bag} onChange={e => setNewRung({...newRung, is_moon_bag: e.target.value === 'true'})}>
                    <option value="false">No</option><option value="true">Yes</option>
                  </select>
                </div>
              </div>
              <button onClick={addRung} className="st-btn" style={s.btn} disabled={saving}>{saving ? 'Adding...' : 'Add target'}</button>
            </div>
          </div>
        )}

        {activeTab === 'goals' && (
          <div style={s.section}>
            <h2 style={s.sectionTitle}>Tax & wealth goals</h2>
            <div style={s.grid2}>
              <div style={s.field}><label style={s.label}>Target net worth ($)</label><input className="st-input" style={s.input} type="number" value={goals.target_net_worth || ''} onChange={e => setGoals({...goals, target_net_worth: e.target.value})} placeholder="1000000" /></div>
              <div style={s.field}><label style={s.label}>Target year</label><input className="st-input" style={s.input} type="number" value={goals.target_year || ''} onChange={e => setGoals({...goals, target_year: e.target.value})} placeholder="2030" /></div>
              <div style={s.field}><label style={s.label}>Monthly DCA ($)</label><input className="st-input" style={s.input} type="number" value={goals.monthly_dca || ''} onChange={e => setGoals({...goals, monthly_dca: e.target.value})} placeholder="500" /></div>
              <div style={s.field}><label style={s.label}>Risk tolerance</label>
                <select className="st-input" style={s.input} value={goals.risk_tolerance || 'medium'} onChange={e => setGoals({...goals, risk_tolerance: e.target.value})}>
                  <option value="low">Low</option><option value="medium">Medium</option><option value="high">High</option>
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Filing status</label>
                <select className="st-input" style={s.input} value={goals.filing_status || 'single'} onChange={e => setGoals({...goals, filing_status: e.target.value})}>
                  <option value="single">Single</option>
                  <option value="married_joint">Married filing jointly</option>
                  <option value="married_separate">Married filing separately</option>
                  <option value="head_of_household">Head of household</option>
                </select>
              </div>
              <div style={s.field}><label style={s.label}>Federal tax bracket</label>
                <select className="st-input" style={s.input} value={goals.income_bracket || '22'} onChange={e => setGoals({...goals, income_bracket: e.target.value})}>
                  <option value="10">10%</option><option value="12">12%</option><option value="22">22%</option>
                  <option value="24">24%</option><option value="32">32%</option><option value="35">35%</option><option value="37">37%</option>
                </select>
              </div>
              <div style={s.field}><label style={s.label}>State of residence</label><select className="st-input" style={s.input} value={goals.state_of_residence || ""} onChange={e => setGoals({...goals, state_of_residence: e.target.value})}><option value="">Select state...</option>{["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"].map(st => <option key={st} value={st}>{st}</option>)}</select></div>
            </div>
            <button onClick={saveGoals} className="st-btn" style={s.btn} disabled={saving}>{saving ? 'Saving...' : 'Save changes'}</button>
          </div>
        )}

        {activeTab === 'account' && (
          <div style={s.section}>
            <h2 style={s.sectionTitle}>Account</h2>
            <div className="st-row" style={s.row}><div><div style={s.rowTitle}>Email</div><div style={s.rowSub}>{user?.email}</div></div></div>
            <div className="st-row" style={{...s.row, borderBottom: 'none'}}><div><div style={s.rowTitle}>Plan</div><div style={{...s.rowSub, textTransform:'capitalize'}}>{user?.subscription_tier}</div></div></div>
            {user?.subscription_tier !== 'free' && (
              <div style={s.dangerSection}>
                <div style={s.dangerHeader}>
                  <div style={s.dangerIconChip}><Icon name="alert" size={16} color="#dc2626" /></div>
                  <h3 style={s.dangerTitle}>Cancel subscription</h3>
                </div>
                <p style={s.dangerDesc}>You will keep access until the end of your current billing period.</p>
                <button onClick={cancelSubscription} style={s.dangerBtn}>Cancel subscription</button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#fafaf8', fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif" },
  loading: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafaf8', color: '#6b6b6b', fontFamily: "'Inter', system-ui, sans-serif" },
  content: { maxWidth: '820px', margin: '0 auto', padding: '3rem 2rem' },
  sectionLabel: { fontSize: '12px', fontWeight: '600', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#1a6b4a', marginBottom: '0.6rem' },
  pageTitle: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '32px', fontWeight: '400', color: '#1a1a1a', marginBottom: '1.75rem', letterSpacing: '-0.01em' },
  success: { display:'flex', alignItems:'center', gap:'8px', background: 'rgba(74,222,128,0.12)', border: '1px solid rgba(26,107,74,0.2)', color: '#1a6b4a', padding: '10px 14px', borderRadius: '8px', fontSize: '14px', fontWeight:'600', marginBottom: '1rem' },
  error: { display:'flex', alignItems:'center', gap:'8px', background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', padding: '10px 14px', borderRadius: '8px', fontSize: '14px', fontWeight:'600', marginBottom: '1rem', cursor: 'pointer' },
  tabs: { display: 'flex', gap: '4px', marginBottom: '2rem', background: '#fff', padding: '5px', borderRadius: '12px', border: '1px solid rgba(0,0,0,0.07)', boxShadow:'0 2px 6px rgba(16,40,28,0.05)', width: 'fit-content', flexWrap: 'wrap' },
  tab: { display:'flex', alignItems:'center', gap:'7px', padding: '9px 16px', borderRadius: '9px', border: 'none', background: 'transparent', fontSize: '13px', fontWeight:'600', color: '#6b6b6b', cursor: 'pointer', fontFamily: "'Inter', system-ui, sans-serif", transition:'all 0.15s ease' },
  tabActive: { background: '#0f2a1c', color: '#fff' },
  section: { background: '#fff', borderRadius: '18px', padding: '2rem', border: '1px solid rgba(0,0,0,0.07)', boxShadow:'0 2px 6px rgba(16,40,28,0.06)' },
  sectionTitle: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '20px', fontWeight: '500', color: '#1a1a1a', marginBottom: '1.4rem' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 4px', borderBottom: '1px solid rgba(0,0,0,0.06)', borderRadius:'10px', transition:'box-shadow 0.15s ease' },
  rungRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 14px', marginBottom: '8px', background:'#f9f9f7', borderRadius:'10px', transition:'box-shadow 0.15s ease' },
  rowLeft: { display: 'flex', alignItems: 'center', gap: '12px' },
  badge: { width: '36px', height: '36px', borderRadius: '50%', background: 'rgba(74,222,128,0.16)', color: '#1a6b4a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: '700' },
  rowTitle: { fontSize: '14px', fontWeight: '700', color: '#1a1a1a' },
  rowSub: { fontSize: '12px', color: '#6b6b6b', marginTop: '2px' },
  editBtn: { fontSize: '13px', fontWeight:'600', color: '#1a6b4a', background: 'rgba(74,222,128,0.1)', border: '1px solid rgba(26,107,74,0.2)', borderRadius: '7px', padding: '6px 14px', cursor: 'pointer' },
  deleteBtn: { fontSize: '13px', fontWeight:'600', color: '#dc2626', background: 'transparent', border: '1px solid #fecaca', borderRadius: '7px', padding: '6px 14px', cursor: 'pointer' },
  cancelBtn: { fontSize: '13px', fontWeight:'600', color: '#6b6b6b', background: 'transparent', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '7px', padding: '6px 14px', cursor: 'pointer' },
  addSection: { marginTop: '1.75rem', paddingTop: '1.75rem', borderTop: '1px solid rgba(0,0,0,0.07)' },
  addTitle: { fontSize: '14px', fontWeight: '700', color: '#1a1a1a', marginBottom: '1rem' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '1.75rem' },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '12px', marginBottom: '1rem' },
  field: { display: 'flex', flexDirection: 'column' },
  label: { fontSize: '11px', fontWeight: '600', color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '7px' },
  input: { padding: '11px 14px', border: '1px solid rgba(0,0,0,0.12)', borderRadius: '8px', fontSize: '14px', color: '#1a1a1a', outline: 'none', fontFamily: "'Inter', system-ui, sans-serif", background: '#fff' },
  btn: { padding: '11px 22px', background: '#1a6b4a', color: '#fff', border: 'none', borderRadius: '9px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', fontFamily: "'Inter', system-ui, sans-serif", boxShadow:'0 6px 16px rgba(26,107,74,0.22)' },
  empty: { fontSize: '14px', color: '#6b6b6b', padding: '1rem 0' },
  dangerSection: { marginTop: '1.75rem', paddingTop: '1.75rem', borderTop: '1px solid rgba(0,0,0,0.07)' },
  dangerHeader: { display:'flex', alignItems:'center', gap:'10px', marginBottom:'0.5rem' },
  dangerIconChip: { width:'32px', height:'32px', borderRadius:'9px', background:'rgba(220,38,38,0.1)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 },
  dangerTitle: { fontSize: '14px', fontWeight: '700', color: '#dc2626' },
  dangerDesc: { fontSize: '13px', color: '#6b6b6b', marginBottom: '1rem', lineHeight: '1.5' },
  dangerBtn: { padding: '10px 20px', background: 'transparent', color: '#dc2626', border: '1px solid #fecaca', borderRadius: '8px', fontSize: '14px', fontWeight: '700', cursor: 'pointer' }
};
